<template>
  <h2 class="title heading-m">Описание</h2>
  <div
    v-if="text"
    ref="descriptionRef"
    data-copy="for-copied"
    class="body-l-regular-long block-text-description"
    :class="{ 'block-text-description--collapsed': more && !isBot }"
  >
    <RenderHTML :seotext="text" />
  </div>
  <ui-ui-link
    v-if="showMore && !isBot"
    :font-weight="400"
    :icon-after="more ? 'down' : 'up'"
    :responsive-ico="true"
    font-class="body-l-regular"
    @click="clickMore"
  >
    {{ more ? 'Читать полностью' : 'Свернуть' }}
  </ui-ui-link>
</template>

<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import RenderHTML from '~/components/ui/RenderHTML.vue';

const globalStore = useGlobalStore();
const isBot = computed(() => globalStore.isBot);
const props = defineProps({
  seoData: {
    type: Object as any,
    required: true,
  },
});

const descriptionRef = ref<HTMLElement>();
const more = ref<boolean>(true);
const text = computed(() => props.seoData?.page?.text);
const clickMore = () => {
  more.value = !more.value;
  if (more.value && window && descriptionRef.value) {
    nextTick(() => {
      descriptionRef.value.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    });
  }
};
const showMore = computed(() => {
  if (!import.meta.env.SSR && descriptionRef.value) {
    const { clientHeight, scrollHeight } = descriptionRef.value;
    const isOverflow = scrollHeight > clientHeight;
    more.value = isOverflow;
    return isOverflow;
  }
  return false;
});
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 16px;
  @include md-block {
    margin-bottom: 20px;
  }
  @include lg-block {
    margin-bottom: 24px;
  }
}

.block-text-description {
  &--collapsed {
    max-height: 328px;
    overflow-y: hidden;
    margin-bottom: 8px;
    position: relative;
  }

  &--collapsed:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 17.12%,
      #fff 92.8%
    );
    height: 40px;
  }

  &:deep(p:last-child) {
    margin-bottom: 0;
  }
}
</style>
